__turbopack_context__.v({
  "aiChat": "PlasmicLayout2-module__UoOgRq__aiChat",
  "button": "PlasmicLayout2-module__UoOgRq__button",
  "checkbox": "PlasmicLayout2-module__UoOgRq__checkbox",
  "container": "PlasmicLayout2-module__UoOgRq__container",
  "containerhidden": "PlasmicLayout2-module__UoOgRq__containerhidden",
  "containertoggle": "PlasmicLayout2-module__UoOgRq__containertoggle",
  "containertopBar": "PlasmicLayout2-module__UoOgRq__containertopBar",
  "customer": "PlasmicLayout2-module__UoOgRq__customer",
  "customertopBar": "PlasmicLayout2-module__UoOgRq__customertopBar",
  "freeBox___21Luv": "PlasmicLayout2-module__UoOgRq__freeBox___21Luv",
  "freeBox__aMiuE": "PlasmicLayout2-module__UoOgRq__freeBox__aMiuE",
  "freeBox__cepbb": "PlasmicLayout2-module__UoOgRq__freeBox__cepbb",
  "freeBox__fcHZp": "PlasmicLayout2-module__UoOgRq__freeBox__fcHZp",
  "freeBox__kiaHf": "PlasmicLayout2-module__UoOgRq__freeBox__kiaHf",
  "freeBox__llgW1": "PlasmicLayout2-module__UoOgRq__freeBox__llgW1",
  "freeBox__o9Won": "PlasmicLayout2-module__UoOgRq__freeBox__o9Won",
  "freeBox__q8CuD": "PlasmicLayout2-module__UoOgRq__freeBox__q8CuD",
  "freeBox__sQVC": "PlasmicLayout2-module__UoOgRq__freeBox__sQVC",
  "freeBox__tjSmh": "PlasmicLayout2-module__UoOgRq__freeBox__tjSmh",
  "freeBox__ukhYr": "PlasmicLayout2-module__UoOgRq__freeBox__ukhYr",
  "freeBox__wHqqJ": "PlasmicLayout2-module__UoOgRq__freeBox__wHqqJ",
  "freeBoxtopBar__aMiuEpc8We": "PlasmicLayout2-module__UoOgRq__freeBoxtopBar__aMiuEpc8We",
  "freeBoxtopBar__sQVCpc8We": "PlasmicLayout2-module__UoOgRq__freeBoxtopBar__sQVCpc8We",
  "globalSupabaseFetchConfigInitializer": "PlasmicLayout2-module__UoOgRq__globalSupabaseFetchConfigInitializer",
  "h5": "PlasmicLayout2-module__UoOgRq__h5",
  "linkCard": "PlasmicLayout2-module__UoOgRq__linkCard",
  "menuItem__nZaj9": "PlasmicLayout2-module__UoOgRq__menuItem__nZaj9",
  "menuItem__zUux": "PlasmicLayout2-module__UoOgRq__menuItem__zUux",
  "myMenu": "PlasmicLayout2-module__UoOgRq__myMenu",
  "navigationShell": "PlasmicLayout2-module__UoOgRq__navigationShell",
  "notificationCenter2__ahWpw": "PlasmicLayout2-module__UoOgRq__notificationCenter2__ahWpw",
  "notificationCenter2__dLjhi": "PlasmicLayout2-module__UoOgRq__notificationCenter2__dLjhi",
  "realtimeStatusIndicator__iIaxy": "PlasmicLayout2-module__UoOgRq__realtimeStatusIndicator__iIaxy",
  "realtimeStatusIndicator__khKGo": "PlasmicLayout2-module__UoOgRq__realtimeStatusIndicator__khKGo",
  "root": "PlasmicLayout2-module__UoOgRq__root",
  "section__lwvMz": "PlasmicLayout2-module__UoOgRq__section__lwvMz",
  "section__zis6J": "PlasmicLayout2-module__UoOgRq__section__zis6J",
  "sectiondarkMode__lwvMzks0If": "PlasmicLayout2-module__UoOgRq__sectiondarkMode__lwvMzks0If",
  "sectiontopBar__lwvMzPc8We": "PlasmicLayout2-module__UoOgRq__sectiontopBar__lwvMzPc8We",
  "sectiontopBar__zis6Jpc8We": "PlasmicLayout2-module__UoOgRq__sectiontopBar__zis6Jpc8We",
  "sideEffect": "PlasmicLayout2-module__UoOgRq__sideEffect",
  "subMenu": "PlasmicLayout2-module__UoOgRq__subMenu",
  "supabaseRpcProvider": "PlasmicLayout2-module__UoOgRq__supabaseRpcProvider",
  "svg___9YvkZ": "PlasmicLayout2-module__UoOgRq__svg___9YvkZ",
  "svg__fpDtA": "PlasmicLayout2-module__UoOgRq__svg__fpDtA",
  "svg__oUa8P": "PlasmicLayout2-module__UoOgRq__svg__oUa8P",
  "svg__t3Aj7": "PlasmicLayout2-module__UoOgRq__svg__t3Aj7",
  "text___8RkrQ": "PlasmicLayout2-module__UoOgRq__text___8RkrQ",
  "text__a7Yxj": "PlasmicLayout2-module__UoOgRq__text__a7Yxj",
  "text__ccwTx": "PlasmicLayout2-module__UoOgRq__text__ccwTx",
  "text__joahh": "PlasmicLayout2-module__UoOgRq__text__joahh",
  "text__k1Max": "PlasmicLayout2-module__UoOgRq__text__k1Max",
  "text__ne0IS": "PlasmicLayout2-module__UoOgRq__text__ne0IS",
  "text__sDfVc": "PlasmicLayout2-module__UoOgRq__text__sDfVc",
  "text__wOghq": "PlasmicLayout2-module__UoOgRq__text__wOghq",
  "text__ydL5N": "PlasmicLayout2-module__UoOgRq__text__ydL5N",
  "text__yfZzw": "PlasmicLayout2-module__UoOgRq__text__yfZzw",
  "text__zNjeW": "PlasmicLayout2-module__UoOgRq__text__zNjeW",
  "text__zdh5C": "PlasmicLayout2-module__UoOgRq__text__zdh5C",
});
